module.exports = __webpack_public_path__ + "static/media/toggle_Elipse_Horizontal.a9b61034.svg";